"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.developerExperienceService = exports.DeveloperExperienceService = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _common = require("@insided/shared/utils/common");

/* eslint-disable class-methods-use-this */
var STAGING_DOMAIN = 'almostinsided.com';
/**
 * Parse a ticket instance hostname to extract instance name and ticket number
 *
 * Works in both server-side (Node.js) and client-side (browser) environments
 *
 * @param hostname - The hostname to parse (e.g., 'mycompany.TICKET-123.almostinsided.com')
 * @returns Parsed ticket instance information or null if not a valid ticket instance hostname
 *
 * @example
 * ```typescript
 * const info = parseTicketInstanceUrl('mycompany.TICKET-123.almostinsided.com');
 * console.log(info?.instanceName); // 'mycompany'
 * console.log(info?.ticketNumber); // 'TICKET-123'
 * ```
 */

function parseTicketInstanceUrl(hostname) {
  try {
    // Split domain name: [instanceName, ticketNumber, subdomain, domain]
    var parts = hostname.split('.');

    if (parts.length !== 4) {
      return null;
    }

    var _parts = (0, _slicedToArray2.default)(parts, 4),
        instanceName = _parts[0],
        ticketNumber = _parts[1],
        subdomain = _parts[2],
        domain = _parts[3]; // Validate it's the expected staging domain


    if ("".concat(subdomain, ".").concat(domain) !== STAGING_DOMAIN) {
      return null;
    }

    return {
      instanceName: instanceName,
      ticketNumber: ticketNumber,
      hostname: hostname
    };
  } catch (error) {
    // Invalid hostname format
    return null;
  }
}
/**
 * Developer Experience Service Class
 *
 * Handles environment detection and provides getters for ticket instance information.
 * Works in both server-side (Node.js) and client-side (browser) environments.
 */


var DeveloperExperienceService = /*#__PURE__*/function () {
  function DeveloperExperienceService() {
    (0, _classCallCheck2.default)(this, DeveloperExperienceService);
  }

  (0, _createClass2.default)(DeveloperExperienceService, [{
    key: "isDebugModeClient",
    value:
    /**
     * Check if debug mode is active (client-side)
     * Requires BOTH: ⚙️ module enabled AND 🔎 query param present
     */
    function isDebugModeClient() {
      if (DeveloperExperienceService.isServer) return false;

      var moduleEnabled = _common.common.isModuleActive('__debugMode');

      var queryParamPresent = new URLSearchParams(window.location.search).has('__debugMode');
      return moduleEnabled && queryParamPresent;
    }
    /**
     * Check if debug mode is active (server-side)
     * Requires BOTH: ⚙️ module enabled AND 🔎 query param present
     */

  }, {
    key: "isDebugModeServer",
    value: function isDebugModeServer(url, modules) {
      var _modules$includes;

      var moduleEnabled = (_modules$includes = modules === null || modules === void 0 ? void 0 : modules.includes('__debugMode')) !== null && _modules$includes !== void 0 ? _modules$includes : false;
      var queryParamPresent = url.searchParams.has('__debugMode');
      return moduleEnabled && queryParamPresent;
    }
    /**
     * Check if the current environment is a staging ticket instance
     *
     * Note: Only works in client-side (browser) environments where window.location is available
     * Returns false when run on server-side (Node.js) as context is not easily available
     *
     * @returns True if currently on a staging ticket instance
     */

  }, {
    key: "isStagingClientSafe",
    get: function get() {
      if (DeveloperExperienceService.isClient) {
        return window.location.hostname.endsWith(STAGING_DOMAIN);
      }

      return false;
    }
    /**
     * Get the current ticket instance information from the current page URL
     *
     * Note: Only works in client-side (browser) environments where window.location is available
     * Returns null when run on server-side (Node.js) as context is not easily available
     *
     * @returns Parsed ticket instance information or null if not on a ticket instance or not in browser
     */

  }, {
    key: "currentTicketInstanceClient",
    get: function get() {
      if (DeveloperExperienceService.isClient) {
        return parseTicketInstanceUrl(window.location.hostname);
      }

      throw new Error('Acts as "use client" directive');
    }
  }], [{
    key: "isClient",
    get:
    /**
     * Check if running in client-side (browser) environment
     *
     * @returns True if running in browser
     */
    function get() {
      return typeof window !== 'undefined';
    }
    /**
     * Check if running in server-side (Node.js) environment
     *
     * @returns True if running in Node.js
     */

  }, {
    key: "isServer",
    get: function get() {
      return typeof window === 'undefined';
    }
  }]);
  return DeveloperExperienceService;
}(); // Export singleton instance for use across the application
// This instance works in both server-side (Node.js) and client-side (browser) environments


exports.DeveloperExperienceService = DeveloperExperienceService;
var developerExperienceService = new DeveloperExperienceService();
exports.developerExperienceService = developerExperienceService;